export default __webpack_public_path__ + "static/media/CharlesBridge.7aee3806.JPG";